import isEmpty from 'lodash-es/isEmpty';

import { deleteRequest, getRequest, postRequest, putRequest } from '@fo-apis/axios';

const updateUserPassword = async (payload = {}) => {
  const res = await putRequest({
    url: `/api/v1/member/my-info/password`,
    data: { ...payload },
    withCredentials: true,
  });

  return res?.code;
};

const getMemberInfo = () =>
  getRequest({
    url: `/api/v1/member/my-info`,
  });

const getMypageMemberInfoDetail = () =>
  postRequest({
    url: `/api/v1/member/my-info/my-page`,
    withCredentials: true
  },
    { skipError: false, },
  );

const getMemberInfoDetail = (payload) =>
  postRequest({
    url: `/api/v1/member/my-info?detail`,
    data: { ...payload },
  },
  {skipError: false },);

const updateMyInfoDetail = (payload = {}) =>
  putRequest({
    url: `/api/v1/member/my-info?detail`,
    data: { ...toUpdateRequest(payload) },
  });

const toUpdateRequest = (data) => {
  const [cellphoneNumber1, cellphoneNumber2, cellphoneNumber3] = data.cellphoneNumber.split('-');
  const email =
    data.emailDomain.key === 'custom'
      ? `${data.emailId}@${data.customEmailDomain}`
      : `${data.emailId}@${data.emailDomain.value}`;
  const interestCodeList = data.myInterestList.filter((i) => i.checked).map((i) => i.code);

  return {
    loginId: data.loginId,
    memberName: data.memberName,
    email,
    cellphoneNumber1,
    cellphoneNumber2,
    cellphoneNumber3,
    birthday: data.birthday,
    emailReceive: data.emailReceive,
    smsReceive: data.smsReceive,
    genderCode: isEmpty(data.myGenderList?.filter((i) => i?.checked))
      ? ''
      : data.myGenderList?.filter((i) => i?.checked)[0].code,
    interestCodeList,
    certificationInfo: data.certificationInfo,
    // 백엔드에서 Google siteverify api 호출시 필요한 토큰, 액션 값
    recaptchaToken: data.recaptchaToken,
    recaptchaAction: data.recaptchaAction,
  };
};

const getWithdrawReasonList = () =>
  getRequest({
    url: '/api/v1/member/my-info/withdraw-reason',
  });

const withdrawUser = (data) =>
  deleteRequest({
    url: '/api/v1/member/my-info/withdraw',
    data: data,
  });

const updateAdultCertificationDate = (mobiliansResult) =>
  putRequest({
    url: '/api/v1/member/my-info/adult-cert',
    data: mobiliansResult,
  });

const updateEmailDisagree = (payload = {}) =>
  putRequest({
    url: `/api/v1/member/my-info/dm-email-disagree`,
    data: { ...payload },
  });

const updateMultimallCertInfo = (payload) =>
  putRequest({
    url: '/api/v1/member/my-info/update-multimall-certinfo',
    data: payload,
  });

const updateMyInfoUseOtp = (payload) =>
  postRequest({
    url: `/api/v1/member/my-info/otp`,
    data: payload,
    withCredentials: true
  });


const getAnnivInfo = (payload) =>
  postRequest({
    url: `/api/v1/member/my-info/annivedit`,
    data: { ...payload },
  });

const updateAnnivInfo = (payload = {}) =>
  putRequest({
    url: `/api/v1/member/my-info/annivedit`,
    data: { ...toUpdateRequestAnniv(payload) },
  });

const toUpdateRequestAnniv = (data) => {
  return {
    loginId: data.loginId,
    emailReceive: data.emailReceive,
    smsReceive: data.smsReceive,
    password: data.password,
    weddCelebDate: data.weddCelebDate,
  };
};

const memberMyInfoApi = {
  updateUserPassword,
  getMemberInfo,
  getMemberInfoDetail,
  getMypageMemberInfoDetail,
  updateMyInfoDetail,
  getWithdrawReasonList,
  withdrawUser,
  updateAdultCertificationDate,
  updateEmailDisagree,
  updateMultimallCertInfo,
  updateMyInfoUseOtp,
  getAnnivInfo,
  updateAnnivInfo,
};

export default memberMyInfoApi;
